import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function activateLicense(licenseKey: string) {
  return requests.post(`${LicenseEndpoints.LICENSE}/${licenseKey}/activate`, {})
}

export default activateLicense
